import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';

//types
import {VendorDeliveryInfoVM} from '../model/types'

@IonicPage()
@Component({
  selector: 'page-deliveryinfo',
  templateUrl: 'deliveryinfo.html',
})
export class DeliveryinfoPage {
  
  deliveryDet:VendorDeliveryInfoVM[];
 
  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              public viewCtrl: ViewController,
              ) {
    this.deliveryDet = navParams.data.deliveryDet || [];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeliveryinfoPage');
  }
  dismiss(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/deliveryinfo/deliveryinfo.ts